import DataroomNodeViewModal from './DataroomNodeViewModal.component';

export default DataroomNodeViewModal;
